export const SET_LEASE_ACTION_COUNT = "SET_LEASE_ACTION_COUNT"

export interface LeaseActionableApprovalState {
	actionableRequestCount: number
}

interface SetLeaseActionableApprovalCount {
	type: typeof SET_LEASE_ACTION_COUNT
	payload: number
}

export type LeaseApprovalTypes = SetLeaseActionableApprovalCount
